<template>
  <van-nav-bar
  title="中国传媒大学新生选床登录"
/>
<div class="indexlogo">
  <img src="../../images/zhongchuan.png" style="width:260px;" border="0" />
  </div>
  <van-form @submit="onSubmit" ref="formline">
    <van-field
      v-model="form.loginname"
      name="loginname"
      label="身份证号"
      placeholder="请填写身份证号" 
      :rules="[{ required: true, message: '请填写身份证号' }]" 
    />     
    <van-field
      v-model="form.password"
      type="password"
      name="password"
      label="密  码"
      placeholder="请用初始密码登录：身份证后六位"
      :rules="[{ required: true, message: '请填写密码' }]" 
      
    />
    <van-field name="checkbox">
      <template #input>
        <van-checkbox v-model="form.checkbox" shape="square" />
       <span style="margin-left: 10px">请阅读</span> <a href="/m/prompt" >重要提示 </a>
      </template>
    </van-field>

    <div style="margin: 16px" v-if="info.isopen==true">
      <van-row gutter="20">
        <van-col span="12"
          ><van-button block type="primary" class="button-cuc"  @click="onDelete" 
            >重置</van-button
          ></van-col
        >
        <van-col span="12" 
          ><van-button block type="primary" class="button-cuc" native-type="submit" 
            >登录</van-button
          ></van-col
        >
      </van-row>
    </div>
   <div style="margin: 16px;color:#000;" v-if="info.isopen==false">
     <p v-html="info.txt" style="white-space: pre-wrap;text-align:left;"></p>

   </div>
  </van-form>
    <div class="login-copyright">Copyright © {{new Date().getFullYear()}} 中国传媒大学 All Rights Reserved.</div>

</template>
<style lang="scss" scoped>
   .login-copyright {
    position:relative;
    margin-top:40%;
  }
  .button-cuc{
  color: #fff;
  background: #059490;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  text-align: center;
  font-weight: 500;
  padding: 7px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.van-row{
  border: 0;
}
.van-col{
  border: 0;
}
</style>
<script>
import { reactive } from "vue";
import { Toast } from "vant";
import Route from "../../router/index";
import { login } from "../../http/api.ts";
import { GetWebSiteSet } from "../../http/api.ts";
import { GetSetTime } from "../../http/api.ts";
import { Dialog } from 'vant';

export default {
  setup() {
    let form = reactive({
      loginname: "",
      password: "",
      checkbox: "",
    });
    let info = reactive({      
      txt:"",
      isopen:false
    });
    let dataFun = async () => {
      await GetSetTime().then((res) => {
        if(res.datas){
          info.isopen=true;        
        }else {
          info.isopen=false;    
        }
      });
      await GetWebSiteSet().then((res) => {        
          info.txt=res.datas.openDesc;        
      });
    };
  
    dataFun();
    return {
      form,info   
    };
  },
  mounted() {
    if (!this._isMobile()) {
      Route.push("/");
    }
  },
  methods: {
    onSubmit(form) {
      if(!form.checkbox){
        Toast.fail("请先阅读重要提示");
        return false;
      }
      const toast1 = Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      login(form).then((res) => {
        
        if (res.code == 202||res.code == 200) {
          
          localStorage.setItem("userToken", "Bearer " + res.token);
          localStorage.setItem("username", res.datas.student_Name);
           if(res.msg=="已选房"){      
                  Dialog.alert({
                    title: '提示',
                    message:  '您已完成选床操作，请在PC端(http://gyxf.cuc.edu.cn)登录,认真阅读《中国传媒大学学生公寓住宿协议书》，打印《中国传媒大学学生公寓住宿信息确认表》和《国传媒大学学生公寓住宿协议书》，本人签字确认并粘贴一寸照片，办理入住手续时交于公寓管理人员。'                    ,allowHtml:true
                  }).then(() => {
                    Route.push("/m/houseview?tmsite="+Math.random());
                  });      
           }else{
              Toast.success(res.msg);
              setTimeout(function () {
                Route.push("/m/read?tmsite="+Math.random());
              }, 1000);
           }
         
        } else {
          Dialog.alert({
            title: '提示',
            message:  res.msg,allowHtml:true
          }).then(() => {
            // on close
          });
        }
        toast1.clear();
      });
    },
    onDelete() {
        this.form.loginname='';
        this.form.password='';
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>